// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"close-octagon"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8.06595 2.49951L15.936 2.49951L21.501 8.06448V15.9345L15.936 21.4995H8.06595L2.50098 15.9345L2.50098 8.06448L8.06595 2.49951Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.06497 2.49963L15.935 2.49963L21.5 8.06461V15.9347L15.935 21.4996H8.06497L2.5 15.9347L2.5 8.06461L8.06497 2.49963Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.1823 8.818L12.0007 11.9996M12.0007 11.9996L8.81836 15.182M12.0007 11.9996L15.1823 15.1813M12.0007 11.9996L8.81836 8.81732","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CloseOctagonIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'close-octagon',
    ref,
    icon: element,
  },
));

CloseOctagonIcon.displayName = 'CloseOctagonIcon';

export default CloseOctagonIcon;
